import remHelper from './getRemValue'
import media from './mediaQueries'

export const getRemValue = remHelper
export const mediaQuery = media
